<template>
<div class="row bg-white p-5">
      <div class="col-5 ml-2  border border-dark p-1 mt-1 mb-1" v-for="i in parseInt(sinav.sorusayi)" :key="i" :id="'soru'+i">
        <div v-if="insertProgress[i-1]>-1" class="position-absolute" style="top:0;right:2px">
          <div v-if="insertProgress[i-1]===0">
            <img src="/images/loading.gif" width="32" >
          </div>
          <div v-else>
            <img src="/images/save.png" width="32">
          </div>
        </div>
        <Question :model="textareas[i-1]" :kacinci="i" @datachanged="dataChanged(i,$event)"/>
        <img v-if="imagesUrl[i-1]" :src="imagesUrl[i-1]" class="w-100"/>
        <div class="progress" v-if="uploadProgress[i-1]>-1">
          <div class="progress-bar" role="progressbar"  :style="'width: '+uploadProgress[i-1]+'%'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <label :for="'file'+i" class="mt-2">
          <input type="file" accept="image/*" :id="'file'+i" class="d-none" @change="imageUpload(i-1,$event)"/>
          <div class="btn btn-outline-info btn-sm" ><i class="fa fa-image"></i> Resim Yükle</div>
        </label>
          <div v-for="a in answerData"  :key="a.data" class="w-100 d-flex justify-content-center align-items-center ">

            <input type="radio"   :name="'radio'+i" class="custom-checkbox mr-2 mt-2" @click="dataRadioChange(i-1,a.data)" :checked="trueAnswers[i-1]===a.data"/>
            <TextInput class="w-100" :placeholder="'Cevap '+a.name" name="cevap" :model="answers[i-1][a.data]" v-on:datachanged="dataInputChanged(a.data,i,$event)" :title="'Cevap '+a.name" />
          </div>
      </div>
  <div class="form-group w-100 mt-2">
    <Button title="Soruları Kaydet" class-name="btn-outline-success w-100" :onclick="updateData"/>
  </div>
  </div>

</template>

<script>
import { findSortedData, get, remove, insert } from '@/crud'
import TextInput from '@/components/forms/TextInput'
import Button from '@/components/forms/Button'
import Question from '@/components/Question'
import firebase from 'firebase'
export default {
  name: 'Sinavlar',
  components: {
    Button,
    TextInput,
    Question

  },
  data () {
    return {
      tableName: '',
      upTableName: '',
      sinav: { sorusayi: 0 },
      sorular: [],
      showedData: [],
      dataWillDelete: { show: false, baslik: '' },
      sort: 'asort',
      textareas: [],
      images: [],
      imagesUrl: [],
      answers: [],
      trueAnswers: [],
      uploadProgress: [],
      insertProgress: [],
      answerData: [{ name: 'A', data: 'a' }, { name: 'B', data: 'b' }, { name: 'C', data: 'c' }, {
        name: 'D',
        data: 'd'
      }, { name: 'E', data: 'e' }],
      rows: 3
    }
  },
  methods: {
    setTableName () {
      const upTable = this.$route.params.ne === 'konu' ? 'konu-testleri-sinavlar' : 'deneme-sinavlar'
      this.upTableName = upTable + '/' + this.$route.params.routeid + '/' + this.$route.params.id
      const table = this.$route.params.ne === 'konu' ? 'konu-testleri-sorular' : 'deneme-sorular'
      this.tableName = table + '/' + this.$route.params.id
    },
    workContent () {
      this.sorular = findSortedData(this.sort, this.sorular)
      this.showedData = this.sorular
    },
    dataChanged (i, data) {
      this.textareas[i - 1] = data
      // this[name] = data
    },
    dataInputChanged (letter, i, data) {
      this.answers[i - 1][letter] = data
      // this[name] = data
    },
    dataRadioChange (index, letter) {
      this.trueAnswers[index] = letter.toUpperCase()
    },
    updateData () {
      remove(this.tableName, () => {
        for (let i = 0; i < parseInt(this.sinav.sorusayi); i++) {
          this.insertProgress[i] = 0
          const object = { soru: this.textareas[i], dc: this.trueAnswers[i].toUpperCase(), ca: this.answers[i].a, cb: this.answers[i].b, cc: this.answers[i].c, cd: this.answers[i].d, ce: this.answers[i].e, kacinci: i + 1 }
          if (this.images[i] && this.images[i] !== null && this.images[i] !== '') {
            object.im = this.images[i]
          }
          insert(this.tableName, object, () => {
            this.insertProgress[i] = 1
          })
        }
      })
    },
    imageUrl (url) {
      return firebase.storage().ref('/sorular/' + url + '.png').getDownloadURL().then(function (url) {
        return url
      })
    },
    imageUpload (i, e) {
      const name = Date.now()
      const self = this
      const uploadTask = firebase.storage().ref('/sorular/' + name + '.png').put(e.target.files[0])
      uploadTask.on('state_changed', function (snapshot) {
        const progress = parseInt(((snapshot.bytesTransferred / snapshot.totalBytes) * 100))
        self.uploadProgress[i] = progress
        /* switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log('Upload is paused')
            break
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log('Upload is running')
            break
        } */
      }, function (error) {
        console.log(error)
      }, function () {
        uploadTask.snapshot.ref.getDownloadURL().then(function (url) {
          self.imagesUrl[i] = url
          self.images[i] = name.toString()
          self.uploadProgress[i] = -1
        })
      })
    }
  },
  created () {
    this.$store.dispatch('setLoading', true)
    this.setTableName()
    get({
      child: this.upTableName,
      callback: (e) => {
        this.sinav = e.val()
        for (let i = 0; i < parseInt(this.sinav.sorusayi); i++) {
          this.textareas[i] = ''
          this.images[i] = ''
          this.answers[i] = { a: '', b: '', c: '', d: '', e: '' }
          this.trueAnswers[i] = ''
          this.uploadProgress[i] = -1
          this.uploadProgress[i] = -1
        }
        get({
          child: this.tableName,
          callback: (e) => {
            this.sorular = this.makeArray(e.val())
            this.sorular.map((v, i) => {
              this.textareas[i] = v.soru
              this.answers[i] = { a: v.ca, b: v.cb, c: v.cc, d: v.cd, e: v.ce }
              this.trueAnswers[i] = v.dc.toLowerCase()
              this.images[i] = ''
              if (v.im) {
                this.images[i] = v.im
                this.imageUrl(v.im).then(url => {
                  this.imagesUrl[i] = url
                })
              }
            })
            this.workContent()
            this.$store.dispatch('setLoading', false)
          }
        })
      }
    })
  }
}
</script>
